import React, { Component } from 'react';
import Button from 'components/button/button';
import { injectIntl } from 'react-intl';
import Hero from 'components/heroes/hero';
import Page from 'components/page/page';
import MakeHash from 'make-hash';
import { Link } from 'react-router-dom';
import Endpoints from 'helpers/enums/endpoints';
import classNames from 'classnames';
import Text from 'components/text/text';
import messages from './messages';

class Verify extends Component {
    constructor(props) {
        super(props);

        const { intl } = this.props;

        this.state = {
            serverError: false,
            loaderActive: false,
            formMessages: [],
            loading: false,
            showLogin: false,
        };

        this.page = {
            heading: intl.formatMessage(messages.verify_account_header),
        };

        this.setUpHandlers();
    }

    /**
     * Binds any handlers to the correct context
     *
     * @method  setUpHandlers
     */
    setUpHandlers() {
        this.goToSignIn = this.goToSignIn.bind(this);
        this.handleError = this.handleError.bind(this);
        this.verifyAccount = this.verifyAccount.bind(this);
    }

    /**
     * React Lifecycle Hook
     * Invoked once, immediately after the initial rendering occurs.
     *
     * @method  componentDidMount
     */
    componentDidMount() {
        const params = new URLSearchParams(window.location.search);
        const email = params.get('email');
        const verificationCode = params.get('verification_code');

        const errorMessages = [];
        if (!email) errorMessages.push('Email is missing');
        if (!verificationCode)
            errorMessages.push('Verification code is missing');

        if (errorMessages.length > 0) {
            // Problem, tell the user
            this.setState({
                loading: false,
                serverError: true,
                formMessages: [
                    ...errorMessages,
                    <Link to="/sign-in/">Go sign in to your account</Link>,
                ],
            });
        } else {
            this.setState({
                loading: true,
            });
            this.verifyAccount(email, verificationCode);
        }
    }

    /**
     * Handles submission of login form
     * Will validate email and password fields
     * based on their latest values
     *
     * @method  handleSubmit
     */
    verifyAccount(email, verificationCode) {
        // TODO: validate the confirmPassword

        // const isValid = !this.formHasErrors(); // Do password check final

        this.props.apiService
            .post(
                Endpoints.verify,
                {
                    email,
                    verificationCode,
                    client: 'rider',
                },
                this.handleError
            )
            .then((data) => {
                if (typeof data === 'undefined') return;

                const message = messages[data.reason];

                if (message) {
                    return this.setState({
                        showLogin: true,
                        loading: false,
                        serverError: false,
                        formMessages: [this.props.intl.formatMessage(message)],
                    });
                } else {
                    return this.setState({
                        showLogin: true,
                        loading: false,
                        serverError: false,
                        formMessages: [
                            this.props.intl.formatMessage(
                                messages.EMAIL_VERIFIED
                            ),
                        ],
                    });
                }
            });
    }

    handleError(error) {
        error.response.json().then((errorBody) => {
            // Try to translate first error
            // EMAIL_NOT_VERIFIED, or USER_NOT_ACCEPTED_TERMS or INVALID_USERNAME_OR_PASSWORD
            if (errorBody.errors) {
                const firstError = errorBody.errors[0];
                const message = messages[firstError.message];

                // errors may look like  so handle if they are present in our messages
                if (message) {
                    return this.setState({
                        loading: false,
                        serverError: true,
                        formMessages: [this.props.intl.formatMessage(message)],
                    });
                }
            }

            // Use reason from the server if were unable to find error enum in our locales
            if (errorBody.reason) {
                return this.setState({
                    loading: false,
                    serverError: true,
                    formMessages: [errorBody.reason],
                });
            }

            // Use untranslated "non_field_errors" if that is present
            if (errorBody.non_field_errors) {
                return this.setState({
                    loading: false,
                    serverError: true,
                    formMessages: errorBody.non_field_errors,
                });
            }

            // Use a final catch-all error if none of the above applied
            this.setState({
                loading: false,
                serverError: true,
                formMessages: ['Uknown error. Please try again.'],
            });
        });
    }

    goToSignIn() {
        this.props.history.replace('/sign-in');
    }

    formHasErrors() {
        let errors = this.fields.filter((field) => {
            const hasError =
                field.state.isError || field.input.value.trim().length === 0;

            if (hasError) {
                field.setState({ isError: true });
            }

            return hasError;
        });

        return errors.length > 0;
    }

    _renderHero() {
        return (
            <Hero title={this.page.heading} supportingTxt={this.page.intro} />
        );
    }

    _renderFormMessages() {
        const ulClasses = classNames('form-messages', {
            'form-messages_hasMessage': this.state.formMessages.length > 0,
        });
        const color = this.state.serverError ? 'DefaultOrange' : 'DefaultBlue';

        return (
            <ul className={ulClasses}>
                {this.state.formMessages.map((msg, i) => {
                    if (typeof msg == 'string') {
                        return (
                            <li key={MakeHash(`${msg}-${i}`)}>
                                <Text color={color} weight="light">
                                    {msg.endsWith('.') ? msg : msg + '.'}
                                </Text>
                            </li>
                        );
                    } else {
                        return <li key={MakeHash(`${i}`)}>{msg}</li>;
                    }
                })}
            </ul>
        );
    }

    render() {
        const { intl } = this.props;
        const pageHero = this._renderHero();

        const formMessages = this._renderFormMessages();
        const hidden = this.state.showLogin ? '' : 'hidden';

        return (
            <Page
                title={this.page.heading}
                pageHero={pageHero}
                isLoading={this.state.loading}
            >
                <div className="container container_constrainedMd">
                    <div className="gigya-screen-set" id="userScreensDiv" />

                    <div className="set mix-set_alignCenter">
                        {formMessages}
                        <div className={hidden}>
                            <Button
                                animateOnClick
                                onClick={this.goToSignIn}
                                className="btn_fixedWidth"
                            >
                                {intl.formatMessage(messages.sign_in_label)}
                            </Button>
                        </div>
                    </div>
                </div>
            </Page>
        );
    }
}

export default injectIntl(Verify);



// WEBPACK FOOTER //
// ./src/client/pages/auth/verify.jsx